'use client'

import { Box, Stack, Typography, type SxProps } from '@mui/material'
import {
  ButtonsRenderer,
  SectionWrapper,
  type ButtonsRendererData,
} from '@components/common'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { type StylesClassNames } from './styles'

export type LayoutCtaBannerData = {
  heading: string
  description?: string
  buttonsRendererData?: ButtonsRendererData
}

export type LayoutCtaBannerProps = LayoutCtaBannerData & {
  csx?: CustomStyles<StylesClassNames>
  sx?: SxProps
  showDivider?: 'top' | 'bottom' | 'both' | 'none'
}

export function LayoutCtaBanner({
  csx,
  heading,
  description,
  buttonsRendererData,
  sx,
  showDivider = 'top',
}: LayoutCtaBannerProps) {
  const styles = getStyles(defaultStyles, csx)

  return (
    <SectionWrapper csx={{ wrapper: sx }} showDivider={showDivider} alternateBg>
      <Box {...styles('wrapper')}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Typography variant="h4.700" color="text.primaryDark" maxWidth="100%">
            {heading}
          </Typography>

          {description ? (
            <Typography
              variant="body1.500"
              color="text.primaryDark"
              maxWidth="80%"
            >
              {description}
            </Typography>
          ) : null}

          {!!buttonsRendererData?.buttonData?.length && (
            <Box {...styles('buttonsWrapper')}>
              <ButtonsRenderer
                {...buttonsRendererData}
                darkTheme
                csx={{
                  wrapper: styles('buttonsRenderer').sx,
                }}
              />
            </Box>
          )}
        </Stack>
      </Box>
    </SectionWrapper>
  )
}
